import { AdvancedOneCustomerFilters } from "../config/GlobalCacheLoader.service";
import { BaseFilters } from "./base-filter-model";

export class ContractModel extends BaseFilters {
    division: string;
    dataView: string;
    topLevelContractGroup: string[] | undefined;
    secondLevelContractFilter: string[] | undefined;
    thirdLevelContractFilter: string[] | undefined;
    fourthLevelContractFilter: string[] | undefined;
    accts: string[] | undefined;
    oneCustomerName?:string | undefined;
    oneCustomerFilters?:AdvancedOneCustomerFilters | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    inferredH5?: string[];

    constructor(
        division:string,
        dataView:string,
        regions?: string[],
        countries?: string[],
        period?: string,
        presentationType?: string,
        translation?: string,
        topLevelContractGroup?: string[],
        secondLevelContractFilter?: string[],
        thirdLevelContractFilter?: string[],
        fourthLevelContractFilter?: string[],
        accts?:string[],
        oneCustomerName?:string,
        oneCustomerFilters?:AdvancedOneCustomerFilters,
        excludeDeletedAccounts?: boolean
    ){
        super(regions, countries, period, presentationType, translation);
        this.division = division;
        this.dataView = dataView;
        this.topLevelContractGroup = topLevelContractGroup;
        this.secondLevelContractFilter = secondLevelContractFilter;
        this.thirdLevelContractFilter = thirdLevelContractFilter;
        this.fourthLevelContractFilter = fourthLevelContractFilter;
        this.accts = accts;
        this.period = period;
        this.oneCustomerName = oneCustomerName;
        this.oneCustomerFilters = oneCustomerFilters;
        this.excludeDeletedAccounts = excludeDeletedAccounts;
    }

    override toString(): string{
        return `topLevelContractGroup=${this.topLevelContractGroup},
                secondLevelContractFilter=${this.secondLevelContractFilter},
                thirdLevelContractFilter=${this.thirdLevelContractFilter},
                fourthLevelContractFilter=${this.fourthLevelContractFilter},
                accts=${this.accts},
                period=${this.period},
                division=${this.division},
                dataView=${this.dataView},
                oneCustomerName=${this.oneCustomerName},
                oneCustomerFilters=${this.oneCustomerFilters},
                excludeDeletedAccounts=${this.excludeDeletedAccounts}
                `;
    }
}